<script>
  import * as BusinessBL from "../bl/business-bl";
  import * as OrderDAL from "../dal/order-dal";

  import { business } from "../stores.js";
  import { onMount, tick } from "svelte";
  import SalesGraph from "./SalesGraph.svelte";
  import SummaryGraph from "./SummaryGraph.svelte";
  import OrdersList from "./OrdersList.svelte";

  let to;

  let from;

  let orders;

  export let params;

  let now = new Date(),
    month,
    day,
    year;

  onMount(() => {
    now.setDate(now.getDate() + 1); //add 24 hours
    (month = "" + (now.getMonth() + 1)),
      (day = "" + now.getDate()),
      (year = now.getFullYear());

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    to = [year, month, day].join("-");
    from = [year, month, "01"].join("-");
  });

  async function getOrders() {
    let _from = new Date(from);
    let _to = new Date(to);
    _to = new Date(_to.getTime() + 86400000); //add 24 hours so 'to' date will be inclusive
    if ($business)
      orders = await OrderDAL.getOrdersByDates($business.code, _from, _to);

    //filter cancled orders
    orders = orders.filter((order) => {
      return !order.cancled && !order.refunded;
    });

    orders.sort((a, b) => {
      return b.createdAt.seconds - a.createdAt.seconds;
    });
  }

  $: {
    if (!$business || $business.code != params.code) {
      BusinessBL.getBusiness(params.code);
    }
  }

  $: {
    if (from && to && $business) {
      getOrders();
    }
  }

  $: {
    console.log(orders);
  }

</script>

<div class="graphs">
  <div class="selectDates">
    מ-<input type="date" bind:value={from} />
    עד-<input type="date" bind:value={to} />
  </div>

  <SalesGraph {orders} {from} {to} />
  <SummaryGraph {orders} />

  <div class="orders">
    <div class="listHeader">הזמנות מ-{from} עד- {to}</div>
    <OrdersList {orders} />
  </div>
</div>

<style>
  .graphs {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    direction: rtl;
    font-size: 14px;
  }

  .listHeader {
    padding: 10px;
  }
  .selectDates {
    padding: 10px;
    margin: 10px 0;
  }

  .selectDates > input[type="date"] {
    border-radius: 4px;
    border: 1px solid #00000000;
    margin: 3px;
    padding: 8px 16px;
    box-shadow: 0 8px 6px -12px;
  }

</style>
